import React from 'react'
import styles from './Rating.module.css'


const Ratings = ({avgQAScore}: any) => {
    return (
        <div className={`${styles.ratingsContainer} text-center d-flex`}>
            <div className={`${styles.rating} p-3`}>
                <h6>QA Score</h6>
                <div>
                    <span>
                        {
                            avgQAScore?.ai_analysed ?
                                (
                                    avgQAScore?.review_score < 0 ? 
                                        '0%' : 
                                        `${Math.round(avgQAScore?.review_score)}%`
                                ):
                                (
                                    avgQAScore?.review_score ? 
                                        (
                                            avgQAScore?.review_score < 0 ? 
                                                '0%' : 
                                                `${Math.round(avgQAScore?.review_score)}%`
                                        ) 
                                        : '-'
                                )
                        }
                    </span>
                </div>
            </div>
            <div className={`${styles.rating} p-3`}>
                <h6>CSAT</h6>
                <div>
                    <span>-</span>
                </div>
            </div>
        </div>
    )
}

export default Ratings
